import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import TypographyWithI18N from 'shared/components/TypographyWithI18N';
import CandidateModalResume from './candidateModalResume';
import { getEmployeeFullName } from 'utilities/utilityFunctions';
import styles from './candidateResumeData.module.scss';

export interface ICandidateResumeProps {
  candidateId?: any;
  firstName?: any;
  lastName?: any;
}

const CandidateResumeData: React.FC<ICandidateResumeProps> = ({
  candidateId,
  firstName,
  lastName,
}) => {
  return (
    <Box className={styles.resumeContainer}>
      <TypographyWithI18N
        className='kfic2-bodyText'
        id='candidate-details-resume'
        data-testid='candidate-details-resume'
        i18nKey='resume'
        textSuffix={':'}
        variant='body1'
      />
      <Box
        sx={{
          '#candidate-name-resume': {
            marginBottom: '0 !important',
            whiteSpace: 'normal !important',
            wordWrap: 'break-word !important',
            overflowWrap: 'anywhere !important',
          },
          marginLeft: 1,
          flexWrap: 'wrap',
        }}
      >
        <CandidateModalResume
          candidateId={candidateId}
          candidateName={getEmployeeFullName({
            firstName: firstName,
            lastName: lastName,
          })}
          fromFullProfile={false}
        />
      </Box>
    </Box>
  );
};

export default CandidateResumeData;
